/**
 * Usage: 
 *   $('div').depthFirst();
 * sorts the elements by deepest first.
 * 
 * See http://stackoverflow.com/questions/5755827/jquery-traversing-order-depth-first
 */

$.fn.depthFirst = function(){
    var ar = this.map(function(){
    			return {
    				length: $(this).parents().length, 
    				elt: this
    			};
        	 }).get();
	var result = [];
	var i = ar.length;

    ar.sort(function(a, b){
        return a.length - b.length;
    });

    while(i--){
    	result.push(ar[i].elt);
    }
    return $(result);
};
